import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

class GlennsHouseExterior extends Scene {
  async init() {
    this.image = require("@/images/Vincent_Glenns_House.png");

    this.title = "Glenn's House";
    this.description = "";
  }
  get options() {
    return [
      new Choice("Enter Glenn's House", async () => {
        if (this.state.inventory.glenn.has) {
          this.description =
            "SONNY YANG: I've already acquired Glenn's services";
          this.audio = require("@/audio/Pandemic-80-Sonny-MP3.mp3");
        } else if (this.state.storylines.fenceOpened) {
          this.description =
            "SONNY YANG: The poor man has had enough for one day. I’d best leave him be.";
          this.audio = require("@/audio/Pandemic-81-Sonny-MP3.mp3");
        } else {
          await this.navigate(scenes.GlennsHouse());
        }
      }),
      new Choice("Go Left", async () => await this.navigate(scenes.Harbour())),
      new Choice("Go Right", async () => await this.navigate(scenes.BurgerJoint())),
    ];
  }
}

export default new GlennsHouseExterior();
